const quickFilterList = require("../../../server/data/systemFilterPresetList");

const state = {
  quickFilterList,
};

export default {
  namespaced: true,
  state,
};
